import { OrganisationState } from '../types';

export function handleSetGoogleAccessToken(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { code } = action.payload;
  return {
    ...state,
    googleAccessToken: code,
  };
}

export function handleSetDriveScannerStatus(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { googleStatus, oneDriveStatus } = action.payload;
  return {
    ...state,
    googleDriveStatus: googleStatus ?? state.googleDriveStatus,
    oneDriveStatus: oneDriveStatus ?? state.oneDriveStatus,
  };
}

export function handleGetFilesUploadHistory(
  state: OrganisationState,
  _action: any
): OrganisationState {
  return {
    ...state,
    filesUploadHistory: undefined,
  };
}

export function handleSetFilesUploadHistory(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { data } = action.payload;
  return {
    ...state,
    filesUploadHistory: data,
  };
}

export function handleReceiptFileStatus(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { fileId, link, connectionId } = action.payload;
  const normalizedFileId = String(fileId ?? '').trim();

  return {
    ...state,
    organisations: state?.organisations?.map((org) => {
      if (org.uuid !== connectionId && org.connectionId !== connectionId) {
        return org;
      }

      return {
        ...org,
        excelFilesMetadata: org?.excelFilesMetadata?.map((file) => {
          if (String(file.excelMetadataId ?? '').trim() !== normalizedFileId) {
            return file;
          }

          return {
            ...file,
            isPosted: true,
            linkToProvider: link ?? file.linkToProvider ?? null,
          };
        }),
      };
    }),
  };
}

export function handleDisconnectFolder(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { type } = action.payload;
  if (type === 'google') {
    return {
      ...state,
      googleDriveStatus: undefined,
    };
  } else if (type === 'one') {
    return {
      ...state,
      oneDriveStatus: undefined,
    };
  }

  return state;
}

export function handleSetScanEmail(
  state: OrganisationState,
  action: any
): OrganisationState {
  const { response } = action.payload;
  return {
    ...state,
    scanEmailDetails: response,
  };
}
